import { render, staticRenderFns } from "./adminMainIndex.vue?vue&type=template&id=ba46e7a0"
import script from "./adminMainIndex.vue?vue&type=script&lang=js"
export * from "./adminMainIndex.vue?vue&type=script&lang=js"
import style0 from "./adminMainIndex.vue?vue&type=style&index=0&id=ba46e7a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports